"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8ArrayToHashObject = exports.hashObjectToUint8Array = void 0;
const hashObject_1 = require("@chainsafe/as-sha256/lib/hashObject");
function hashObjectToUint8Array(obj) {
    const byteArr = new Uint8Array(32);
    hashObject_1.hashObjectToByteArray(obj, byteArr, 0);
    return byteArr;
}
exports.hashObjectToUint8Array = hashObjectToUint8Array;
function uint8ArrayToHashObject(byteArr) {
    return hashObject_1.byteArrayToHashObject(byteArr);
}
exports.uint8ArrayToHashObject = uint8ArrayToHashObject;
